import { SET_STATISTICS } from '../types';

const customersReducer = (state, action) => {
  switch(action.type) {
    case SET_STATISTICS:
      return {
        ...state,
        aggregate: action.payload.aggregate,
        days: action.payload.days,
        statisticsUpdatedAt: action.payload.updated,
        statisticsLoaded: true
      }
    default:
      return {
        ...state
      }
  }
}

export default customersReducer